// initial
var Init = function () {

    var form;

    var Load = function () {


        $(form).on('click', '.top', function (event) {
            event.preventDefault();

            let list = form.querySelector('.list');

            if ($(list).css('display') == 'none') {
                $(list).css('display', '')
            } else {

                $(list).toggle();
            }
        })


    }

    return {
        init: function () {
            form = document.getElementById('list-category');
            if (!form) {
                return;
            }
            Load();
        },
    };

}();




$(function () {

    Init.init();
});